






























import moment from "moment";

import { Component, Vue } from 'vue-property-decorator';
import Logout from '@/components/Logout.vue';
import AttendanceNavbar from "@/components/AttendanceNavbar.vue";
import AttendanceProfile from "@/components/AttendanceProfile.vue";
import Title from "@/components/Title.vue";

import AttendanceTable from "@/components/AttendanceTable.vue";

import { AuthUtile } from "../../auth/AuthUtile";
import { DbUtile, ResultDbCourseManagement } from "../../database/DbUtile";
import { DbUser, DbUserCourseManagement, DbUserCourseManagementDetail } from '../../database/DbUser';
import { DbCourseManagement, DbCourseManagementDetails } from "../../database/DbCourseManagement";
import { DbHistoryManagement, DbHistoryManagementDetail } from '../../database/DbHistoryManagement'

import Common from "@/common/Common";

@Component({
  components: {
    AttendanceNavbar,
    AttendanceProfile,
    AttendanceTable,
    Logout,
    Title
  }
})
export default class Attendance extends Vue {
  private authUtile: AuthUtile = new AuthUtile();
  private dbUtile: DbUtile = new DbUtile();

  // 現在日時
  now = new Date();

  // 講習一覧
  courseManagements: ResultDbCourseManagement[] = [];


  userId: string | null = null;
  user: DbUser | null = null;

  // 受講中 - 受講登録して 受講完了していない講習
  notattendedRows: DbCourseManagement[] = [];

  // 完了
  doneRows: DbCourseManagement[] = [];

  // 期限切れ
  expiredRows: DbCourseManagement[] = [];

  created() {
    console.log('created', this.user);
    this.authUtile.onAuthStateChanged()
      .then((user) => {
        // ログイン済み
        this._created();
      })
      .catch((e) => {
        console.error(e);
        alert('ログインしてください');
        const path = Common.getLoginPath(this.$route.path, this.$route.params.admin);
        this.$router.push(path);
      });
  }

  _created() {
    const currentUser = this.authUtile.currentUser();
    if (currentUser == null){
      return;
    }

    this.dbUtile.getUser(currentUser.uid!)
      .then((u) => {
        console.log('u', u);
        this.userId = u.id!;
        this.user = u.u!;

        // course_managements 講習一覧を取得する
        this.getCourseManagements();
      })
      .catch(e => {
        console.error(e);
        alert('ログインしてください');
        const path = Common.getLoginPath(this.$route.path, this.$route.params.admin);
        this.$router.push(path);
      });
  }

  // course_managements 講習一覧を取得する
  async getCourseManagements() {
    // 講習一覧取得
    this.courseManagements = await this.dbUtile.getCourseManagements("", "");
    console.log("courseManagements", this.courseManagements);

    // ユーザーの講習一覧取得
    const userCourseManagements = await this.dbUtile.getUserCourseManagements(this.userId!);
    console.log("userCourseManagements", userCourseManagements);

    const now = new Date();
    this.notattendedRows = [];
    this.expiredRows     = [];
    this.doneRows        = [];
    userCourseManagements.forEach(async ucm => {
      console.log("ucm", ucm);
      if (ucm == null) return;
      const cm = this.courseManagements.filter(cm => cm.id == ucm.id!)[0];
      console.log('cm', cm);
      if (cm === null || typeof cm === "undefined") return;
      const cmData  = cm.data!;
      const ucmData = ucm.courseManagement!;
      cmData.uid = ucm.id!;

      // 講習詳細を取得
      const courseManagementDetails = await this.dbUtile.getCourseManagementDetails(cm.id!);
      // 履歴詳細を取得
      const userHistoryManagementDetails = await this.dbUtile.getUserHistoryManagementDetails(this.userId!, cm.id!, '', '');

      // ユーザ講習概要と詳細のステータスのチェックと更新
      let hasDuring = false;
      let doneCount = 0;
      for (const cmd of courseManagementDetails) {
        const uhmd = userHistoryManagementDetails?.find(uhmd => uhmd.courseManagementDetailsId === cmd.id);
        const ucmd = await Common.getUserCourseManagementDetail(uhmd, this.user!, this.userId!, cm.id!, cmd);
        if (ucmd.status == DbUserCourseManagementDetail.STATUS.During) hasDuring = true;
        if (ucmd.status == DbUserCourseManagementDetail.STATUS.Done)   doneCount++;
      }
      // ユーザ講習概要が完了でない場合はステータスのチェックと更新
      if (ucmData.status != DbUserCourseManagement.STATUS.Done) {
        let status = DbUserCourseManagement.STATUS.NotAttended;
        if      (doneCount === courseManagementDetails.length) status = DbUserCourseManagement.STATUS.Done;
        else if (hasDuring || 0 < doneCount)                   status = DbUserCourseManagement.STATUS.During;
        // ステータスを更新すべき場合はDB更新
        if (Common.checkUpdateStatus(ucmData.status, status)) {
          // ユーザー受講詳細の更新
          console.warn('Update user course management:', ucmData.status, status);
          ucmData.status = status;
          this.dbUtile.updateStatusUserCourseManagement(this.userId!, cm.id!, ucmData.status);
          // ユーザー履歴詳細の更新
          console.warn('Update user history management:', ucmData.status, status);
          const ucm = new DbUserCourseManagement();
          ucm.id     = cm.id!;
          ucm.status = status;
          this.dbUtile.addHistoryManagement(this.userId!, this.user!, cm.id!, ucm);
        }
      }

      // 講習の格納
      if (ucmData.status == DbUserCourseManagement.STATUS.Done) {
        // 現在日が受講期間内のライブ配信章があるか確認
        const existDuringLiveDetail = courseManagementDetails.some(d => {
          const cmd = d.courseManagementDetails!;
          return cmd.classification === 'ライブ配信' && new Date(cmd.from) <= now && now <= new Date(cmd.to);
        });
        if (existDuringLiveDetail) {
          // ライブ配信章が1つ以上存在し、現在日がいずれかの受講期間内の場合、常に「受講中」欄に表示する
          this.notattendedRows.push(cmData);
        } else {
          // 受講完了した講習
          const to: any = ucmData.to!;
          if (to != null){
            const toStr = moment(new Date(to.seconds*1000)).format('YYYY-MM-DD');
            cmData.to = toStr;
          }
          this.doneRows.push(cmData);
        }

      } else {
        // DbUserCourseManagement.STATUS.NotAttended
        // DbUserCourseManagement.STATUS.During
        // 期限確認
        const to     = new Date(cmData.to);
        const toStr  = moment(to).format('YYYY-MM-DD');
        const nowStr = moment(this.now).format('YYYY-MM-DD');
        if (toStr >= nowStr)
          this.notattendedRows.push(cmData); // 受講登録して 受講完了していない講習
        else
          this.expiredRows.push(cmData);     // 期限切れ 受講完了せずに終了日を過ぎた講習
      }
      // ソート
      this.sortRows(this.notattendedRows);
      this.sortRows(this.expiredRows);
      this.sortRows(this.doneRows);
    });
  }

  // 講習詳細 ソート
  sortRows(rows: DbCourseManagement[]): DbCourseManagement[]{
    console.log('sortRows', rows);
    rows = rows.sort((a, b) => {
      // 講習ID
      if(a.courseId > b.courseId){
        return 1;
      }
      else if(a.courseId < b.courseId){
        return -1;
      }
      return 0;
    });
    console.log('sort', rows);
    return rows;
  }
}
